import React from "react";
import { Box, FormHelperText, MenuItem, Switch, TextField } from "@material-ui/core";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";
import { DreamHomeInfoSlide } from "../../../types/generalContent";
import CreateContentField from "./CreateContentField";

interface InfoSlidesFieldsProps {
  slides: DreamHomeInfoSlide[];
  pathPrefix: string;
  errors: Record<string, string>;
  handleChange: (e: any) => void;
  onAddCard: (slideIndex: number) => void;
  onRemoveCard: (slideIndex: number, cardId: string) => void;
  onAddPoint: (slideIndex: number) => void;
  onRemovePoint: (slideIndex: number, pointId: string) => void;
  onCurrentPoint: (slideIndex: number, pointIndex: number, checked: boolean) => void;
}

const InfoSlidesFields = ({
  slides,
  pathPrefix,
  errors,
  handleChange,
  onAddCard,
  onRemoveCard,
  onAddPoint,
  onRemovePoint,
  onCurrentPoint,
}: InfoSlidesFieldsProps) => {
  return (
    <>
      {(slides || []).map((info, i) => {
        const slideType = info.type || "cards";
        const base = `${pathPrefix}[${i}]`;

        return (
          <div className="content__fields-item" key={info._id || i}>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Tab title:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name={`${base}.title`}
                      error={!!errors[`${base}.title`]}
                      helperText={errors[`${base}.title`]}
                      onChange={handleChange}
                      value={info.title || ""}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Type:"
                field={
                  <Box>
                    <TextField
                      select
                      label=""
                      size="small"
                      variant="outlined"
                      name={`${base}.type`}
                      error={!!errors[`${base}.type`]}
                      helperText={errors[`${base}.type`]}
                      value={slideType}
                      onChange={(e) =>
                        handleChange({
                          currentTarget: {
                            name: `${base}.type`,
                            value: e.target.value,
                          },
                        })
                      }
                    >
                      <MenuItem value="cards">Cards</MenuItem>
                      <MenuItem value="timeline">Timeline</MenuItem>
                    </TextField>
                  </Box>
                }
              />
            </div>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Heading:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name={`${base}.heading`}
                      error={!!errors[`${base}.heading`]}
                      helperText={errors[`${base}.heading`]}
                      onChange={handleChange}
                      value={info.heading || ""}
                    />
                  </Box>
                }
              />
              {slideType === "cards" && (
                <CreateContentField
                  fieldTitle="Intro:"
                  field={
                    <Box>
                      <TextField
                        label=""
                        size="small"
                        variant="outlined"
                        type="text"
                        name={`${base}.text`}
                        onChange={handleChange}
                        value={info.text || ""}
                      />
                    </Box>
                  }
                />
              )}
            </div>

            {slideType === "cards" && (
              <>
                <div className="content__fields-row centered">
                  <span className="content__item-label">Cards:</span>
                  <button
                    className="content__add-btn centered"
                    type="button"
                    onClick={() => onAddCard(i)}
                  >
                    <AddIcon />
                  </button>
                </div>
                {(info.items || []).map((card, j) => (
                  <div className="content__fields-list-item" key={card._id || j}>
                    <div className="content__fields-row">
                      <CreateContentField
                        fieldTitle="Icon URL:"
                        field={
                          <Box>
                            <TextField
                              label=""
                              size="small"
                              variant="outlined"
                              type="text"
                              name={`${base}.items[${j}].iconUrl`}
                              error={!!errors[`${base}.items[${j}].iconUrl`]}
                              helperText={errors[`${base}.items[${j}].iconUrl`]}
                              onChange={handleChange}
                              value={card.iconUrl || ""}
                            />
                          </Box>
                        }
                      />
                      <CreateContentField
                        fieldTitle="Title:"
                        field={
                          <Box>
                            <TextField
                              label=""
                              size="small"
                              variant="outlined"
                              type="text"
                              name={`${base}.items[${j}].title`}
                              error={!!errors[`${base}.items[${j}].title`]}
                              helperText={errors[`${base}.items[${j}].title`]}
                              onChange={handleChange}
                              value={card.title || ""}
                            />
                          </Box>
                        }
                      />
                      <CreateContentField
                        fieldTitle="Text:"
                        field={
                          <Box>
                            <TextField
                              label=""
                              size="small"
                              variant="outlined"
                              type="text"
                              name={`${base}.items[${j}].text`}
                              error={!!errors[`${base}.items[${j}].text`]}
                              helperText={errors[`${base}.items[${j}].text`]}
                              onChange={handleChange}
                              value={card.text || ""}
                            />
                          </Box>
                        }
                      />
                      {(info.items || []).length > 1 && (
                        <button
                          className="content__delete-btn"
                          type="button"
                          onClick={() => onRemoveCard(i, card._id)}
                        >
                          <RemoveIcon />
                        </button>
                      )}
                    </div>
                    <div className="content__fields-row">
                      <CreateContentField
                        fieldTitle="Link text:"
                        field={
                          <Box>
                            <TextField
                              label=""
                              size="small"
                              variant="outlined"
                              type="text"
                              name={`${base}.items[${j}].linkText`}
                              error={!!errors[`${base}.items[${j}].linkText`]}
                              helperText={errors[`${base}.items[${j}].linkText`]}
                              onChange={handleChange}
                              value={card.linkText || ""}
                            />
                          </Box>
                        }
                      />
                      <CreateContentField
                        fieldTitle="Link URL:"
                        field={
                          <Box>
                            <TextField
                              label=""
                              size="small"
                              variant="outlined"
                              type="text"
                              name={`${base}.items[${j}].linkUrl`}
                              error={!!errors[`${base}.items[${j}].linkUrl`]}
                              helperText={errors[`${base}.items[${j}].linkUrl`]}
                              onChange={handleChange}
                              value={card.linkUrl || ""}
                            />
                          </Box>
                        }
                      />
                    </div>
                  </div>
                ))}
              </>
            )}

            {slideType === "timeline" && (
              <>
                <div className="content__fields-row centered">
                  <span className="content__item-label">Dates:</span>
                  <button
                    className="content__add-btn centered"
                    type="button"
                    onClick={() => onAddPoint(i)}
                  >
                    <AddIcon />
                  </button>
                </div>
                {errors[`${base}.points[0].isCurrent`] && (
                  <FormHelperText error>
                    {errors[`${base}.points[0].isCurrent`]}
                  </FormHelperText>
                )}
                {(info.points || []).map((point, j) => (
                  <div className="content__fields-list-item" key={point._id || j}>
                    <div className="content__fields-row">
                      <CreateContentField
                        fieldTitle="Label:"
                        field={
                          <Box>
                            <TextField
                              label=""
                              size="small"
                              variant="outlined"
                              type="text"
                              name={`${base}.points[${j}].label`}
                              error={!!errors[`${base}.points[${j}].label`]}
                              helperText={errors[`${base}.points[${j}].label`]}
                              onChange={handleChange}
                              value={point.label || ""}
                            />
                          </Box>
                        }
                      />
                      <CreateContentField
                        fieldTitle="Text:"
                        field={
                          <Box>
                            <TextField
                              label=""
                              size="small"
                              variant="outlined"
                              type="text"
                              name={`${base}.points[${j}].text`}
                              error={!!errors[`${base}.points[${j}].text`]}
                              helperText={errors[`${base}.points[${j}].text`]}
                              onChange={handleChange}
                              value={point.text || ""}
                            />
                          </Box>
                        }
                      />
                      <CreateContentField
                        fieldTitle="Current"
                        field={
                          <Box>
                            <Switch
                              checked={!!point.isCurrent}
                              onChange={(e) => onCurrentPoint(i, j, e.target.checked)}
                              color="primary"
                              inputProps={{
                                "aria-label": "Current date",
                                name: `${base}.points[${j}].isCurrent`,
                              }}
                            />
                          </Box>
                        }
                      />
                      {(info.points || []).length > 1 && (
                        <button
                          className="content__delete-btn"
                          type="button"
                          onClick={() => onRemovePoint(i, point._id)}
                        >
                          <RemoveIcon />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
                <div className="content__fields-row centered">
                  <span className="content__item-label">Banner:</span>
                </div>
                <div className="content__fields-row">
                  <CreateContentField
                    fieldTitle="Icon URL:"
                    field={
                      <Box>
                        <TextField
                          label=""
                          size="small"
                          variant="outlined"
                          type="text"
                          name={`${base}.banner.iconUrl`}
                          error={!!errors[`${base}.banner.iconUrl`]}
                          helperText={errors[`${base}.banner.iconUrl`]}
                          onChange={handleChange}
                          value={(info.banner && info.banner.iconUrl) || ""}
                        />
                      </Box>
                    }
                  />
                  <CreateContentField
                    fieldTitle="Label:"
                    field={
                      <Box>
                        <TextField
                          label=""
                          size="small"
                          variant="outlined"
                          type="text"
                          name={`${base}.banner.label`}
                          onChange={handleChange}
                          value={(info.banner && info.banner.label) || ""}
                        />
                      </Box>
                    }
                  />
                  <CreateContentField
                    fieldTitle="Text:"
                    field={
                      <Box>
                        <TextField
                          label=""
                          size="small"
                          variant="outlined"
                          type="text"
                          name={`${base}.banner.text`}
                          error={!!errors[`${base}.banner.text`]}
                          helperText={errors[`${base}.banner.text`]}
                          onChange={handleChange}
                          value={(info.banner && info.banner.text) || ""}
                        />
                      </Box>
                    }
                  />
                </div>
              </>
            )}
          </div>
        );
      })}
    </>
  );
};

export default InfoSlidesFields;
